import { useEffect } from "react";
import { SUPPORTED } from "@/i18n";

const SITE = "https://dadabio.com";

const FALLBACK_DESC = {
  en: "DADABIO is an R&D-driven software engineering house in Istanbul, architecting enterprise software, AI ecosystems and secure cross-border digital platforms for global companies.",
  tr: "DADABIO, İstanbul merkezli Ar-Ge odaklı bir yazılım mühendisliği şirketidir; küresel şirketler için kurumsal yazılım, yapay zekâ ekosistemleri ve güvenli sınır ötesi dijital platformlar geliştirir.",
  de: "DADABIO ist ein F&E-getriebenes Software-Engineering-Haus in Istanbul: Unternehmenssoftware, KI-Ökosysteme und sichere grenzüberschreitende digitale Plattformen für globale Unternehmen.",
  ar: "دادابيو دار هندسة برمجيات مدفوعة بالبحث والتطوير في إسطنبول، تبني برمجيات مؤسسية وأنظمة ذكاء اصطناعي ومنصات رقمية آمنة عابرة للحدود للشركات العالمية.",
  ru: "DADABIO — инжиниринговая компания с фокусом на НИОКР в Стамбуле: корпоративное ПО, экосистемы ИИ и защищённые трансграничные цифровые платформы для глобальных компаний.",
  es: "DADABIO es una casa de ingeniería de software impulsada por I+D en Estambul: software empresarial, ecosistemas de IA y plataformas digitales seguras transfronterizas para empresas globales.",
};

const upsert = (selector, make) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = make();
    document.head.appendChild(el);
  }
  return el;
};

export default function Seo({ lang, t, title, desc, path }) {
  useEffect(() => {
    document.title = title || t.meta.title;
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";

    const descStr = desc || t.meta.desc || FALLBACK_DESC[lang] || FALLBACK_DESC.en;
    upsert('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "description");
      return m;
    }).setAttribute("content", descStr);

    const pageUrl = `${SITE}${path || `/${lang}`}`;
    const og = (p, c) =>
      upsert(`meta[property="${p}"]`, () => {
        const m = document.createElement("meta");
        m.setAttribute("property", p);
        return m;
      }).setAttribute("content", c);
    og("og:title", title || t.meta.title);
    og("og:description", descStr);
    og("og:url", pageUrl);
    og("og:type", "website");
    og("og:site_name", "DADABIO İnovasyon Teknoloji");

    upsert('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    }).setAttribute("href", pageUrl);

    document.head.querySelectorAll('link[data-hreflang="1"]').forEach((n) => n.remove());
    [...SUPPORTED.map((c) => [c, c]), ["x-default", "en"]].forEach(([hreflang, code]) => {
      const l = document.createElement("link");
      l.setAttribute("rel", "alternate");
      l.setAttribute("hreflang", hreflang);
      l.setAttribute("href", `${SITE}${(path || "").replace(/^\/[a-z]{2}/, `/${code}`) || `/${code}`}`);
      l.setAttribute("data-hreflang", "1");
      document.head.appendChild(l);
    });

    let ld = document.getElementById("org-jsonld");
    if (!ld) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.id = "org-jsonld";
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "DADABIO İnovasyon Teknoloji Limited Şirketi",
      alternateName: "DADABIO Innovation Technology",
      url: SITE,
      email: "info@dadabio.com",
      telephone: "+905360594292",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Rumeli Cad. No 7/4",
        addressLocality: "Basaksehir",
        addressRegion: "Istanbul",
        addressCountry: "TR",
      },
      identifier: { "@type": "PropertyValue", propertyID: "D-U-N-S", value: "751161145" },
    });
  }, [lang, t]);

  return null;
}
